import React from 'react'
import { styles } from './styles'

interface PrivateFolderBadgeProps {
  /**
   * Whether the viewer is an admin looking at another member's board (`isAdminView` from the API).
   * The badge is deliberately admin-only: it exists so admins can tell which folders a visitor
   * would not be shown.
   */
  isAdminView?: boolean
  /**
   * The folder's `is_public`. Nullable in the database, so anything other than `true` is private.
   */
  isPublic?: boolean | null
  /** Positioning is the caller's business — pass a class to place it. */
  className?: string
}

/**
 * "private" marker on a folder, shown only to admins.
 *
 * Owns the whole rule so its call sites don't have to repeat it: nothing renders unless the viewer
 * is an admin viewing someone else's board, and a null `isPublic` counts as private.
 */
const PrivateFolderBadge = ({
  isAdminView = false,
  isPublic,
  className,
}: PrivateFolderBadgeProps) => {
  const classes = styles()

  if (!isAdminView || isPublic === true) return null

  return (
    <span className={`${classes.badge}${className ? ` ${className}` : ''}`}>
      private
    </span>
  )
}

export default PrivateFolderBadge
